/* Tirvela collection grid — client-side filter + sort */
(function () {
  if (window.__trvCgridInit) return;
  window.__trvCgridInit = true;

  function init(root) {
    if (!root || root.__trvCgridReady) return;
    root.__trvCgridReady = true;

    const grid = root.querySelector('[data-trv-cgrid-grid]');
    const cards = Array.from(root.querySelectorAll('[data-trv-card]'));
    const checks = Array.from(root.querySelectorAll('[data-trv-cgrid-check]'));
    const sortSelect = root.querySelector('[data-trv-cgrid-sort]');
    const clearBtn = root.querySelector('[data-trv-cgrid-clear]');
    const toggleBtn = root.querySelector('[data-trv-cgrid-toggle]');
    const closeBtn = root.querySelector('[data-trv-cgrid-close]');
    const filters = root.querySelector('[data-trv-cgrid-filters]');
    const noResults = root.querySelector('[data-trv-cgrid-no-results]');
    const visibleCount = root.querySelector('[data-trv-cgrid-visible-count]');
    const activeCount = root.querySelector('[data-trv-cgrid-active-count]');
    const appliedBox = root.querySelector('[data-trv-cgrid-applied]');

    // Prefix → label map (mirrors the sidebar filter labels)
    const PREFIX_LABELS = {
      'linea-': '',
      'function-': '',
      'skin-type-': '',
      'skin-concern-': '',
      'scent-family-': '',
      'type-': '',
      'routine-': '',
    };

    function prettifyTag(tag) {
      if (!tag) return '';
      let s = tag;
      for (const pfx of Object.keys(PREFIX_LABELS)) {
        if (s.indexOf(pfx) === 0) { s = s.slice(pfx.length); break; }
      }
      s = s.replace(/-/g, ' ').trim();
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    function renderApplied() {
      if (!appliedBox) return;
      const a = checks.filter(c => c.checked);
      appliedBox.innerHTML = '';
      if (a.length === 0) return;

      a.forEach(check => {
        const pill = document.createElement('span');
        pill.className = 'trv-cgrid__pill';
        pill.dataset.tag = check.dataset.tag;
        const label = document.createElement('span');
        label.textContent = prettifyTag(check.dataset.tag);
        const x = document.createElement('button');
        x.type = 'button';
        x.className = 'trv-cgrid__pill-x';
        x.setAttribute('aria-label', 'Rimuovi filtro: ' + label.textContent);
        x.innerHTML = '✕';
        x.addEventListener('click', (e) => {
          e.preventDefault();
          check.checked = false;
          apply();
        });
        pill.appendChild(label);
        pill.appendChild(x);
        appliedBox.appendChild(pill);
      });

      if (a.length > 1) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'trv-cgrid__pill-clear-all';
        clear.textContent = 'Reimposta';
        clear.addEventListener('click', (e) => {
          e.preventDefault();
          checks.forEach(c => c.checked = false);
          apply();
        });
        appliedBox.appendChild(clear);
      }
    }

    function active() {
      return checks.filter(c => c.checked).map(c => c.dataset.tag);
    }

    function apply() {
      const a = active();
      // Group active tags by prefix for AND-across-categories, OR-within-category
      const byCategory = {};
      a.forEach(tag => {
        const prefix = tag.split('-').slice(0, 2).join('-') + '-';
        // Use a simpler prefix split — first dash
        const idx = tag.indexOf('-');
        const cat = idx > -1 ? tag.slice(0, idx + 1) : tag;
        if (!byCategory[cat]) byCategory[cat] = [];
        byCategory[cat].push(tag);
      });

      let visible = 0;
      cards.forEach(card => {
        const cardTags = (card.dataset.tags || '').split(',');
        let show = true;
        for (const cat in byCategory) {
          const wanted = byCategory[cat];
          const has = wanted.some(t => cardTags.includes(t));
          if (!has) { show = false; break; }
        }
        if (show) {
          card.removeAttribute('hidden');
          visible++;
        } else {
          card.setAttribute('hidden', '');
        }
      });

      if (visibleCount) visibleCount.textContent = visible;
      if (noResults) noResults.hidden = visible > 0;
      if (activeCount) {
        activeCount.textContent = a.length || '';
        activeCount.dataset.count = a.length;
      }
      renderApplied();
    }

    function sort() {
      const mode = sortSelect ? sortSelect.value : 'featured';
      const sorted = cards.slice();
      if (mode === 'price-asc') sorted.sort((a, b) => +a.dataset.price - +b.dataset.price);
      else if (mode === 'price-desc') sorted.sort((a, b) => +b.dataset.price - +a.dataset.price);
      else if (mode === 'newest') sorted.sort((a, b) => +b.dataset.publishedAt - +a.dataset.publishedAt);
      else if (mode === 'title-asc') sorted.sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || '', 'it'));
      // 'featured' = original order
      sorted.forEach(card => grid.appendChild(card));
    }

    // Auto-apply filters from URL.
    // Supports two formats:
    //   1. Shopify standard:   ?filter.p.tag=type-crema&filter.p.tag=function-anti-eta
    //      (emitted by the mega-header nav links — multi-value, repeatable param)
    //   2. Short custom:       ?f=type-crema,function-anti-eta
    //      (legacy / shareable)
    // After matching checkboxes, the affected filter accordions are auto-expanded
    // so the user can see which filters are active.
    function applyUrlFilters() {
      const params = new URLSearchParams(window.location.search);
      const wanted = [];

      // Shopify-standard repeatable filter params
      params.getAll('filter.p.tag').forEach(v => {
        const s = (v || '').trim();
        if (s) wanted.push(s);
      });

      // Legacy comma-separated ?f= param
      const fParam = params.get('f');
      if (fParam) {
        fParam.split(',').forEach(v => {
          const s = (v || '').trim();
          if (s && wanted.indexOf(s) === -1) wanted.push(s);
        });
      }

      if (wanted.length === 0) return false;

      let matched = 0;
      const expandedDetails = new Set();
      checks.forEach(c => {
        if (wanted.indexOf(c.dataset.tag) !== -1) {
          c.checked = true;
          matched++;
          const det = c.closest('details');
          if (det && !det.open) {
            det.open = true;
            expandedDetails.add(det);
          }
        }
      });
      return matched > 0;
    }
    applyUrlFilters();

    checks.forEach(c => c.addEventListener('change', apply));
    if (sortSelect) sortSelect.addEventListener('change', () => { sort(); });
    if (clearBtn) clearBtn.addEventListener('click', () => {
      checks.forEach(c => c.checked = false);
      apply();
    });

    if (toggleBtn && filters) {
      toggleBtn.addEventListener('click', () => {
        const open = filters.classList.toggle('is-open');
        toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open && window.innerWidth < 990 ? 'hidden' : '';
      });
    }
    if (closeBtn && filters) {
      closeBtn.addEventListener('click', () => {
        filters.classList.remove('is-open');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }

    apply();
  }

  function initAll() {
    document.querySelectorAll('[data-trv-cgrid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
